import React, { useState, useEffect, useContext, useMemo } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";

import moment from "moment";
import AximDropdown from "components/Dropdown/AximDropdown";
import TimeSheetsTable from "components/Content/Table/TimeSheetsTable"
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import { Utils } from "common/Utils";

function TimeSheets (props) {
  const { companyId, userInfo } = useContext(PrivateRoutesContext);

  // PAYDATES DROPDOWN
  const [payDatesDropdown, setPayDatesDropdown] = useState([]);
  const [payDateSelected, setPayDateSelected] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const payDate = useMemo(() => payDateSelected ? moment(payDateSelected).format("YYYY-MM-DD") : "", [payDateSelected]);

  useEffect(() => {
    handleChangeCompany();
  }, [companyId]);

  useEffect(() => {
    if (payDatesDropdown.length > 0) {
      setPayDateSelected(payDatesDropdown[0]);
    }
  }, [payDatesDropdown])

  const canDownload = useMemo(() => {
    return !Utils.isBroker(userInfo);
  },[userInfo]);

  const handleChangeCompany = () => {
    const selectedCompany = localStorage.getItem(`selectedCompanyId`);
    setIsLoading(true);

    apiGet(apiUrls.getDropdown(selectedCompany))
      .then((response) => {
        setPayDatesDropdown(response.data.closedPayPeriods);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <div className={TableStyle.tableWrapper}>
      <div className={TableStyle.filtersWrapper}>
        {payDatesDropdown.length > 0 ? (
          <AximDropdown
            label="Pay Dates"
            handleChange={(e) => setPayDateSelected(e.target.value)}
            value={payDateSelected}
            pairs={payDatesDropdown.map(payDates => ({ value: payDates, text: moment(payDates).format("MMMM DD, YYYY") }))} />
        ) : (
          ""
        )}
      </div>
      <TimeSheetsTable payDate={payDate} isLoading={isLoading} canDownload={canDownload}/>
    </div>
  );
}

export default TimeSheets;
